const MILLISECONDS_PER_SECOND = 1000;
const LOAD_TIME_DECIMAL_PLACES = 2;
export const formatReportLoadSeconds = (durationMs: number): string => (durationMs / MILLISECONDS_PER_SECOND).toFixed(LOAD_TIME_DECIMAL_PLACES);
